export default {
  menuUrl: "https://apim.hc.dubaiholding.com/restaurants/info/v1/", //prod
  orderUrl: "https://apim.hc.dubaiholding.com/restaurants/order/v1/", //prod
  menuApiSubscriptionKey: "3d586a2e59254d3c99ca6c152ef6c483", // prod
  orderApiSubscriptionKey: "6c5d1d1fc52543b0aaa54984b2d02ff1", // prod
  redirect_urls: "emenu.jumeirah.com", // prod
  samsung_redirect_urls: "https://emenu.jumeirah.com",
  orderRoomUrl: "https://services.jumeirah.com/restaurants/info/v1/", // prod
  RoomOrderRoomUrl: "https://services.jumeirah.com/restaurants/order/v1/", // prod
  BackendUrl: "https://services.jumeirah.com", // prod
  RoomOrderApiSubscriptionKey: "98c4c90e70a640afab629b55285edc13", //prod
  BackendUrlSubscriptionKey: "98c4c90e70a640afab629b55285edc13", //prod
  V1TokenSubscriptionKey: "8537c314c33842d99fc76f12c0f0fcd2", //prod
  socket_urls: "wss://bzsocket.testyourapp.online", //prod
  charges_urls: "https://apim.hc.dubaiholding.com/restaurants/order/v1/", //prod
  profileBaseUrl: "https://services.jumeirah.com/profile/v1/", //prod
  profileTokenBaseUrl: "https://services.jumeirah.com/jumeirah/oauth/v2/token", //prod
  V2TokenSubscriptionKey: "98c4c90e70a640afab629b55285edc13", //prod

  // menuUrl: "https://servicesuat.jumeirah.com/restaurants/info/v1/", //uat
  // orderUrl: "https://servicesuat.jumeirah.com/restaurants/order/v1/", // uat
  // menuApiSubscriptionKey: "958c495e3b244f55a4de9adadcf4696a", //uat
  // orderApiSubscriptionKey: "958c495e3b244f55a4de9adadcf4696a", //uat
  // redirect_urls: "jg-emenu.azurewebsites.net", //uat
  // orderRoomUrl: "https://servicesuat.jumeirah.com/restaurants/info/v1/", // uat
  // RoomOrderRoomUrl: "https://servicesuat.jumeirah.com/restaurants/order/v1/", // uat
  // RoomOrderApiSubscriptionKey: "958c495e3b244f55a4de9adadcf4696a", //uat
  // BackendUrlSubscriptionKey: "958c495e3b244f55a4de9adadcf4696a", //uat
  // V1TokenSubscriptionKey: "656ffb30619c456da95f7e80d19c593f", //uat
  // BackendUrl: "https://servicesuat.jumeirah.com", // uat
  // socket_urls: "ws://localhost:6080", //uat
  // charges_urls: "https://apim-uat.hc.dubaiholding.com/restaurants/order/v1/", //uat
  // profileBaseUrl: "https://Servicesuat.jumeirah.com/profile/v2/", //uat
  // profileTokenBaseUrl:
  //   "https://servicesuat.jumeirah.com/jumeirah/oauth/v2/token", //uat
  // V2TokenSubscriptionKey: "9f9a84f21d414ef6b976b6ac443fbfba", //uat

  accessTokenUrl:
    "https://servicesuat.jumeirah.com/jumeirah/payment/v1/identity/auth/access-token",

  paymentApiSubscriptionKey: "574530b54bc44b45a2f8cbeec3f38288",

  transactionOutletUrl:
    "https://servicesuat.jumeirah.com/jumeirah/payment/v1/transactions/outlets/d0275187-3579-49dd-ab9a-b17f6d45b5e2/orders",
};
